/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { components } from '@glowingblue-orell-thalia-common';

const { HomeActivityLeaderboard } = components;
import ReviewsActivityLeaderItem from './ReviewsActivityLeaderItem';
import HomeReviewsLeaderboardState from '../states/HomeReviewsLeaderboardState';
import type User from 'flarum/common/models/User';

export default class HomeReviewsLeaderboard extends HomeActivityLeaderboard {
	listItem(item: User, position: number) {
		return <ReviewsActivityLeaderItem user={item} position={position} />;
	}

	get titleText() {
		return app.translator.trans('glowingblue-orell-rezensionen.forum.home.reviews_leaderboard.title');
	}

	get subTitleText() {
		return app.translator.trans('glowingblue-orell-rezensionen.forum.home.reviews_leaderboard.sub_title', { days: this.nDays });
	}

	get emptyText() {
		return app.translator.trans('glowingblue-orell-rezensionen.forum.home.reviews_leaderboard.empty_text', { days: this.nDays });
	}

	get stateManager() {
		return HomeReviewsLeaderboardState;
	}
}
